<template>
    <div class="my-agents pt-0 w-100">
        <Sidebar class="strip-content" />
        <div class="page-content">
            <PageHeader class="d-flex justify-content-center" pageName="Negotiators" />
            <div class="container">

                <ContentCard class="agents-card pb-4 pt-2 px-2 px-lg-5">
                    <div class="myads__header d-flex flex-row justify-content-between flex-wrap">
                        <ul class="tabs-nav">
                            <li :class="{ 'active': $route.params.active === 'active' }">
                                <a href="#" @click.prevent="replaceRouteParam({ active: 'active' })">
                                    Active
                                    <span v-if="userAgentsTotal['all']">
                                        ({{ userAgentsTotal['active']['count'] }})
                                    </span>
                                </a>
                            </li>
                            <li :class="{ 'active': $route.params.active === 'inactive' }">
                                <a href="#" @click.prevent="replaceRouteParam({ active: 'inactive' })">
                                    Inactive
                                    <span v-if="userAgentsTotal['all']">
                                        ({{ userAgentsTotal['inactive']['count'] }})
                                    </span>
                                </a>
                            </li>
                        </ul>
                        <div class="myads__header-right">
                            <button
                                type="button"
                                class="btn btn--primary"
                                @click.prevent="showCreateInvitationUserModal = true"
                            >
                                <i class="ri-add-line" />
                                Add Negotiator
                            </button>
                        </div>
                    </div>

                    <div class="mt-3" v-show="filteredUserAgents.length">
                        <label>
                            <input
                                type="checkbox"
                                name="hide_tenant_details_on_enquiry"
                                v-model="formData.hide_tenant_details_on_enquiry"
                                @change="changeHideTenantDetails"
                            />
                            Tenant details hidden on enquiry emails
                        </label>
                        <div class="form-error">{{ errors.first('hide_tenant_details_on_enquiry') }}</div>
                    </div>

                    <div class="agents-list" v-if="isLoading">
                        <UserAgentSkeleton
                            v-for="i in arrayGenerator(3)"
                            :key="`user-card-skeleton-${i}`"
                        />
                    </div>

                    <div class="mt-3" v-else-if="!filteredUserAgents.length">
                        <p>You currently have no {{ $route.params.active }} agents.</p>
                    </div>

                    <div class="agents-list" v-else>
                        <UserAgentCard
                            v-for="agent in filteredUserAgents"
                            :key="agent.uuid"
                            :agent="agent"
                        />
                    </div>
                </ContentCard>
            </div>
        </div>

        <CreateInvitationUserModal
            :show-modal="showCreateInvitationUserModal"
            @close="showCreateInvitationUserModal = false"
        />
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { arrayGenerator } from '@helpers/helpers';
import UserAgentCard from '@components/UserAgents/partials/UserAgentCard.vue';
import UserAgentSkeleton from '@/components/UserAgents/partials/UserAgentSkeleton.vue';
import CreateInvitationUserModal from '@/components/UserAgents/partials/CreateInvitationUserModal.vue';
import PageHeader from '@components/partials/PageHeader';
import Sidebar from '@components/partials/Sidebar.vue';

const ContentCard = () => import('@components/ContentCard/ContentCard.vue');

export default {
    $_veeValidate: {
        validator: 'new', // give me my own validator scope.
    },
    components: {
        UserAgentCard,
        UserAgentSkeleton,
        CreateInvitationUserModal,
        PageHeader,
        ContentCard,
        Sidebar,
    },
    data() {
        return {
            isLoading: true,
            showCreateInvitationUserModal: false,
            formData: {
                hide_tenant_details_on_enquiry: false,
            },
        };
    },
    mounted() {
        this.$root.$on('refilter-agents', () => {
            this.filterUserAgents({ active: this.$route.params.active });
        });
    },
    computed: {
        ...mapState('user', [
            'userAgents',
            'userAgentsTotal',
            'filteredUserAgents',
            'user',
        ]),
    },
    watch: {
        $route(to) {
            this.filterUserAgents({ active: to.params.active });
        },
        user(user) {
            this.formData.hide_tenant_details_on_enquiry = user.hide_tenant_details_on_enquiry;
        },
        userAgents() {
            this.isLoading = true;
            this.filterUserAgents({ active: this.$route.params.active });
            this.isLoading = false;
        },
    },
    methods: {
        arrayGenerator,
        ...mapActions('user', [
            'filterUserAgents',
            'updateCompanySettings',
        ]),
        replaceRouteParam(payload) {
            this.$router.push({ params: { ...this.$route.params, ...payload }, query: this.$route.query });
        },
        async changeHideTenantDetails() {
            await this.updateCompanySettings({ uuid: this.user.uuid, ...this.formData });
            window.showToastSuccess('Settings saved.');
        },
    },
};
</script>
